<template><NumberRangeFilter field="resolution" label="Разрешение" @filter="$emit('filter',$event)"/></template>
<script>
import NumberRangeFilter from './NumberRangeFilter.vue'
export default { name:'ResolutionFilter', components:{NumberRangeFilter} }
</script>
